module.exports = __webpack_public_path__ + "img/Cherrytree-full-white.9faab20c.png";